export default __webpack_public_path__ + "static/media/dayparty2019.e2e45188.mp4";